module.exports = __webpack_public_path__ + "static/media/TESAD1.26e77341.png";